import { isFocusable } from "./isFocusable.mjs";
export var getFocusableIn = function getFocusableIn(node) {
  var _node$ownerDocument;
  var treeWalker = node === null || node === void 0 ? void 0 : (_node$ownerDocument = node.ownerDocument) === null || _node$ownerDocument === void 0 ? void 0 : _node$ownerDocument.createTreeWalker(node, NodeFilter.SHOW_ELEMENT, function (node) {
    return 'ownerSVGElement' in node && node.ownerSVGElement ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
  });
  var result = [];
  if (!treeWalker) return result;
  if (isFocusable(treeWalker.currentNode)) {
    result.push(treeWalker.currentNode);
  }
  while (treeWalker.nextNode() !== null) {
    if (isFocusable(treeWalker.currentNode)) {
      result.push(treeWalker.currentNode);
    }
  }
  return result;
};
//# sourceMappingURL=getFocusableIn.mjs.map